module.exports = __webpack_public_path__ + "static/media/safari.312ca97c.svg";